import React, { useState } from 'react';
import { FiUsers, FiAward, FiCalendar, FiBarChart2 } from 'react-icons/fi';
import ResourceAllocationList from '../../components/Resources/ResourceAllocationList';
import UserSkillsList from '../../components/Resources/UserSkillsList';
import ResourceAvailabilityCalendar from '../../components/Resources/ResourceAvailabilityCalendar';
import ResourceUtilizationDashboard from '../../components/Resources/ResourceUtilizationDashboard';
import './Resources.css';

const Resources = () => {
  const [activeTab, setActiveTab] = useState('allocations');

  const tabs = [
    { id: 'allocations', label: 'Allocations', icon: <FiUsers /> },
    { id: 'skills', label: 'Skills', icon: <FiAward /> },
    { id: 'availability', label: 'Availability', icon: <FiCalendar /> },
    { id: 'utilization', label: 'Utilization', icon: <FiBarChart2 /> }
  ];

  return (
    <div className="resources-page">
      <div className="page-header">
        <div className="header-content">
          <h1><FiUsers /> Resource Management</h1>
          <p>Manage team allocations, skills, and availability</p>
        </div>
      </div>

      <div className="tabs-container">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="tab-content">
        {activeTab === 'allocations' && (
          <ResourceAllocationList showStatistics={true} />
        )}
        {activeTab === 'skills' && (
          <UserSkillsList />
        )}
        {activeTab === 'availability' && (
          <ResourceAvailabilityCalendar />
        )}
        {activeTab === 'utilization' && (
          <ResourceUtilizationDashboard />
        )}
      </div>
    </div>
  );
};

export default Resources;

